import { render } from "./ShopRightSidebar.vue?vue&type=template&id=c3f40ba2&ts=true"
import script from "./ShopRightSidebar.vue?vue&type=script&lang=ts"
export * from "./ShopRightSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__